import { Component, OnInit } from '@angular/core';
import { OwlOptions } from 'ngx-owl-carousel-o';
import { AuthServiceService } from '../../shareModule/services/auth-service.service';
import { LocalServiceService } from '../../shareModule/services/local-service.service';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import moment from 'moment';

declare var $: any;

@Component({
  selector: 'app-new-review-info',
  templateUrl: './new-review-info.component.html',
  styleUrls: ['./new-review-info.component.scss']
})
export class NewReviewInfoComponent implements OnInit {

  customOptions: any = {
    margin: 5,
    nav: true,
    dots: false,
    responsive: {
      0: {
        items: 1,
        slideBy: 1
      },
      400: {
        items: 1,
        slideBy: 1
      },
      740: {
        items: 1,
        slideBy: 1
      },
      940: {
        items: 2,
        slideBy: 2
      }
    }
  };
  url_names: any;
  years: { id: string; name: string; }[];
  month: { id: string; name: string; }[];
  staffs: any;
  reviews: any;
  public stars: any[] = new Array(5);
  review_count: any = 0;
  review_count_below: any = 0;
  review_count_five: any = 0;
  review_count_five_below: any = 0;
  review_count_four: any = 0;
  review_count_three: any = 0;
  review_count_two: any = 0;
  review_count_one: any = 0;
  review_count_less_equal_four: any = 0;
  review_count_rank: any = 0;
  review_count_five_rank: any = 0;
  review_count_five_rank_below: any = 0;
  review_count_four_rank: any = 0;
  review_count_three_rank: any = 0;
  review_count_two_rank: any = 0;
  review_count_one_rank: any = 0;
  review_count_less_equal_four_rank: any = 0;
  id: any;
  selectedUrl: any = '';
  selectedYear: any = '';
  selectedMonth: any = '';
  selectedStaff: any = '';
  staffSelected = false;

  constructor(
    private auth: AuthServiceService,
    private local: LocalServiceService,
    private router: Router,
    private toastr: ToastrService
  ) { }

  ngOnInit(): void {
    let m = moment().month() + 1;
    let y = moment().year();
    this.selectedMonth = m < 10 ? '0' + m : m;
    this.selectedYear = y;
    // this.owl();
    // setTimeout(() => {
    //   this.owl2();
    // }, 1000);
    const { id } = this.local.getUser();
    this.id = id;
    this.get_specific_feedback_manager_url();
    this.staff_listing();
    this.review_information();
    this.monthsData();
    this.yearsData();
  }

  formatOne = (percent: number) => `${percent}`;

  get_specific_feedback_manager_url() {
    this.auth.get_specific_feedback_manager_url(this.id).subscribe(
      (response: any) => {
        this.url_names = response.body.c.findFeedbackNames;
      },
      (error) => {
        if (error.status == 401) {
          this.local.logout();
          this.router.navigate(['/admin']);
        }
      }
    );
  }

  staff_listing() {
    let formData = new FormData();
    formData.append('id', this.id);
    formData.append('url', this.selectedUrl);
    formData.append('staff', this.selectedStaff);
    this.auth.staff_listing(formData).subscribe(
      (response: any) => {
        this.staffs = response.body;
      },
      (error) => {
        if (error.status == 401) {
          this.local.logout();
          this.router.navigate(['/admin']);
        }
      }
    );
  }

  reviews_all: any = []
  review_information() {
    let formData = new FormData();
    formData.append('id', this.id);
    formData.append('url', this.selectedUrl);
    formData.append('year', this.selectedYear);
    formData.append('month', this.selectedMonth);
    // formData.append('staff', this.selectedStaff);

    this.auth.review_information(formData).subscribe(
      (response: any) => {
        this.reviews = response.body.reviews;
        let all = [];
        if (this.reviews.length) {
          for (let i in response.body.reviews) {
            for (let j in response.body.reviews[i]) {
              all.push(response.body.reviews[i][j]);
            }
          }
        }

        this.reviews_all = [];
        for (let i = 0; i < all.length; i += 6) {
          this.reviews_all.push(all.slice(i, i + 6));
        }
        console.log(this.reviews_all)
        this.review_count = all.length;
        this.review_count_five = all.filter(x => x.star == 5).length;
        this.review_count_five_below = all.filter(x => x.star == 5).length;
        this.review_count_four = all.filter(x => x.star == 4).length;
        this.review_count_three = all.filter(x => x.star == 3).length;
        this.review_count_two = all.filter(x => x.star == 2).length;
        this.review_count_one = all.filter(x => x.star == 1).length;
        this.review_count_less_equal_four = all.filter(x => x.star < 5).length;
        this.review_count_rank = this.rankRet(this.review_count, this.review_count);
        this.review_count_five_rank = this.rankRet(this.review_count_five, this.review_count);
        this.review_count_five_rank_below = this.rankRet(this.review_count_five, this.review_count);
        this.review_count_four_rank = this.rankRet(this.review_count_four, this.review_count);
        this.review_count_three_rank = this.rankRet(this.review_count_three, this.review_count);
        this.review_count_two_rank = this.rankRet(this.review_count_two, this.review_count);
        this.review_count_one_rank = this.rankRet(this.review_count_one, this.review_count);
        this.review_count_less_equal_four_rank = this.rankRet(this.review_count_less_equal_four, this.review_count);

      },
      (error) => {
        if (error.status == 401) {
          this.local.logout();
          this.router.navigate(['/admin']);
        }
      }
    );
  }

  review_information_staff() {
    let formData = new FormData();
    formData.append('feedbackNameId', this.selectedStaff);

    this.auth.review_information_staff(formData).subscribe(
      (response: any) => {
        this.reviews = response.body.reviews;
        let all = [];
        if (this.reviews.length) {
          for (let i in response.body.reviews) {
            for (let j in response.body.reviews[i]) {
              all.push(response.body.reviews[i][j]);
            }
          }
        }
        // this.review_count = all.length;
        this.review_count_below = all.length;
        // this.review_count_five = all.filter(x => x.star == 5).length;
        this.review_count_five_below = all.filter(x => x.star == 5).length;
        this.review_count_four = all.filter(x => x.star == 4).length;
        this.review_count_three = all.filter(x => x.star == 3).length;
        this.review_count_two = all.filter(x => x.star == 2).length;
        this.review_count_one = all.filter(x => x.star == 1).length;
        // this.review_count_less_equal_four = all.filter(x => x.star < 5).length;
        // this.review_count_rank = this.rankRet(this.review_count, this.review_count);
        // this.review_count_five_rank = this.rankRet(this.review_count_five, this.review_count);
        this.review_count_five_rank_below = this.rankRet(this.review_count_five, this.review_count_below);
        this.review_count_four_rank = this.rankRet(this.review_count_four, this.review_count_below);
        this.review_count_three_rank = this.rankRet(this.review_count_three, this.review_count_below);
        this.review_count_two_rank = this.rankRet(this.review_count_two, this.review_count_below);
        this.review_count_one_rank = this.rankRet(this.review_count_one, this.review_count_below);
        // this.review_count_less_equal_four_rank = this.rankRet(this.review_count_less_equal_four, this.review_count);

      },
      (error) => {
        if (error.status == 401) {
          this.local.logout();
          this.router.navigate(['/admin']);
        }
      }
    );
  }

  review_information_month_year() {
    let formData = new FormData();
    formData.append('id', this.id);
    formData.append('url', this.selectedUrl);
    formData.append('year', this.selectedYear);
    formData.append('month', this.selectedMonth);

    this.auth.review_information(formData).subscribe(
      (response: any) => {
        let all = [];
        if (this.reviews.length) {
          for (let i in response.body.reviews) {
            for (let j in response.body.reviews[i]) {
              all.push(response.body.reviews[i][j]);
            }
          }
        }
        this.review_count = all.length;
        this.review_count_rank = this.rankRet(this.review_count, this.review_count);
        this.review_count_five = all.filter(x => x.star == 5).length;
        this.review_count_five_rank = this.rankRet(this.review_count_five, this.review_count);
        this.review_count_less_equal_four = all.filter(x => x.star < 5).length;
        this.review_count_less_equal_four_rank = this.rankRet(this.review_count_less_equal_four, this.review_count);
      },
      (error) => {
        if (error.status == 401) {
          this.local.logout();
          this.router.navigate(['/admin']);
        }
      }
    );
  }

  onChangeUrl(event) {
    let url = event.target.value;
    if (url.trim().length == 0) {
      return this.toastr.error('URL not allowed.');
    }
    this.selectedUrl = url;
    this.staffSelected = false;
    this.review_information();
    this.staff_listing();
    this.refreshOwl2();
  }

  onChangeYear(event) {
    let year = event.target.value;
    if (year.trim().length == 0) {
      return this.toastr.error('Year not allowed.');
    }
    this.selectedYear = year;
    this.review_information_month_year();
  }

  onChangeMonth(event) {
    let month = event.target.value;
    if (month.trim().length == 0) {
      return this.toastr.error('Month not allowed.');
    }
    this.selectedMonth = month;
    this.review_information_month_year();
  }

  onChangeStaff(event) {
    let staff = event.target.value;
    if (staff.trim().length == 0) {
      return this.toastr.error('Staff not allowed.');
    }
    this.selectedStaff = staff;
    this.staffSelected = true;
    this.review_information_staff();
    this.refreshOwl2();
  }

  refreshOwl2() {
    $(".owl-two").owlCarousel('destroy');
    setTimeout(() => {
      this.owl2();
    }, 1000);
  }

  rankRet(rank: number, maxRank: number) {
    let rankPerct = (rank / maxRank) * 100;
    return rankPerct.toFixed(0);
  }

  owl() {
    // $('.owl-one').owlCarousel({
    //   // loop:true,
    //   margin: 5,
    //   // items: 2,
    //   nav: true,
    //   dots: false,
    //   responsive: {
    //     0: {
    //       items: 1,
    //       slideBy: 1
    //     },
    //     400: {
    //       items: 1,
    //       slideBy: 1
    //     },
    //     740: {
    //       items: 1,
    //       slideBy: 1
    //     },
    //     940: {
    //       items: 2,
    //       slideBy: 2
    //     }
    //   },
    // })
  }

  owl2() {
    // $('.owl-two').owlCarousel({
    //   // loop:true,
    //   margin: 5,
    //   // items: 2,
    //   nav: true,
    //   navText: [`<i class="fas fa-arrow-circle-left"></i>`, `<i class="fas fa-arrow-circle-right"></i>`],
    //   dots: false,
    //   responsive: {
    //     0: {
    //       items: 1,
    //       slideBy: 1
    //     },
    //     400: {
    //       items: 1,
    //       slideBy: 1
    //     },
    //     740: {
    //       items: 1,
    //       slideBy: 1
    //     },
    //     940: {
    //       items: 1,
    //       slideBy: 1
    //     }
    //   },
    // })
  }

  monthsData() {
    this.month = [
      { id: '01', name: 'Jan' },
      { id: '02', name: 'Feb' },
      { id: '03', name: 'Mar' },
      { id: '04', name: 'Apr' },
      { id: '05', name: 'May' },
      { id: '06', name: 'Jun' },
      { id: '07', name: 'Jul' },
      { id: '08', name: 'Aug' },
      { id: '09', name: 'Sep' },
      { id: '10', name: 'Oct' },
      { id: '11', name: 'Nov' },
      { id: '12', name: 'Dec' }
    ]
  }

  yearsData() {
    this.years = [
      { id: '1', name: '2020' },
      { id: '2', name: '2021' },
      { id: '3', name: '2022' },
      { id: '4', name: '2023' },
      { id: '5', name: '2024' },
      { id: '6', name: '2025' },
      { id: '7', name: '2026' },
      { id: '8', name: '2027' },
      { id: '8', name: '2028' },
      { id: '8', name: '2029' },
      { id: '8', name: '2030' }
    ]
  }

}
